(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-comfort-tabs"] && !Shopify.designMode) return;
  try {
    
  class ComfortFeatureTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelectorAll('.comfort-feature-tabs__tab');
      this.panels = this.querySelectorAll('.comfort-feature-tabs__panel');
      if (!this.tabs.length || !this.panels.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activateTab(tab));
      });
    }

    activateTab(tab) {
      if (tab.classList.contains('is-active')) return;

      const index = tab.dataset.panelIndex;

      this.tabs.forEach((item) => {
        const isActive = item === tab;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.panelIndex === index;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }
  }

  if (!customElements.get('comfort-feature-tabs')) {
    customElements.define('comfort-feature-tabs', ComfortFeatureTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-confidence-tabs"] && !Shopify.designMode) return;
  try {
    
  class ProductConfidenceTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.pct-tab'));
      this.panels = Array.from(this.querySelectorAll('.pct-media-panel'));
      if (!this.tabs.length) return;

      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.autoplayMs = parseInt(this.dataset.autoplayMs, 10) || 5000;
      this.loop = this.dataset.loop !== 'false';
      this.activeIndex = this.tabs.findIndex((tab) => tab.classList.contains('is-active'));
      if (this.activeIndex < 0) this.activeIndex = 0;

      this.progressBar = this.tabs[this.activeIndex]?.querySelector('.pct-tab__progress-bar');
      this.onProgressEnd = this.handleProgressEnd.bind(this);
      this.onTabClick = this.handleTabClick.bind(this);
      this.onVisibilityChange = this.handleVisibilityChange.bind(this);

      this.tabs.forEach((tab) => tab.addEventListener('click', this.onTabClick));
      document.addEventListener('visibilitychange', this.onVisibilityChange);

      if (this.autoplayEnabled) {
        this.bindProgressListener();
      }
    }

    disconnectedCallback() {
      this.tabs.forEach((tab) => tab.removeEventListener('click', this.onTabClick));
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.unbindProgressListener();
    }

    handleTabClick(event) {
      const tab = event.currentTarget;
      const index = parseInt(tab.dataset.tabIndex, 10);
      if (Number.isNaN(index) || index === this.activeIndex) return;
      this.activate(index, true);
    }

    handleProgressEnd(event) {
      if (event.animationName !== this.getProgressAnimationName()) return;
      if (!this.autoplayEnabled) return;

      const nextIndex = this.activeIndex + 1;
      if (nextIndex >= this.tabs.length) {
        if (this.loop) {
          this.activate(0, true);
        }
        return;
      }

      this.activate(nextIndex, true);
    }

    handleVisibilityChange() {
      if (!this.autoplayEnabled || !this.progressBar) return;
      this.progressBar.style.animationPlayState = document.hidden ? 'paused' : 'running';
    }

    activate(index, restartProgress) {
      if (index < 0 || index >= this.tabs.length) return;

      this.unbindProgressListener();
      this.tabs.forEach((tab, i) => {
        const isActive = i === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        const bar = tab.querySelector('.pct-tab__progress-bar');
        if (bar) {
          bar.classList.remove('is-animating');
          bar.style.width = '';
        }
      });

      this.panels.forEach((panel, i) => {
        const isActive = i === index;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      this.activeIndex = index;
      this.progressBar = this.tabs[index]?.querySelector('.pct-tab__progress-bar');

      if (restartProgress && this.autoplayEnabled) {
        this.restartProgress();
      } else {
        this.unbindProgressListener();
      }
    }

    restartProgress() {
      if (!this.progressBar) return;
      this.progressBar.classList.remove('is-animating');
      this.progressBar.style.width = '';
      this.progressBar.style.animationPlayState = '';
      void this.progressBar.offsetWidth;
      this.progressBar.classList.add('is-animating');
      this.bindProgressListener();
    }

    bindProgressListener() {
      if (!this.progressBar) return;
      this.progressBar.addEventListener('animationend', this.onProgressEnd);
    }

    unbindProgressListener() {
      if (this.progressBar) {
        this.progressBar.removeEventListener('animationend', this.onProgressEnd);
      }
    }

    getProgressAnimationName() {
      const sectionId = (this.id || '').replace('ProductConfidenceTabs-', '');
      return sectionId ? `pct-progress-fill-${sectionId}` : '';
    }
  }

  if (!customElements.get('product-confidence-tabs')) {
    customElements.define('product-confidence-tabs', ProductConfidenceTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-feature-carousel"] && !Shopify.designMode) return;
  try {
    
  class ProductFeatureCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      if (!this.track || this.slides.length === 0) return;

      this.loop = this.dataset.loop === 'true';
      this.index = 0;

      this.prevBtn?.addEventListener('click', () => this.move(-1));
      this.nextBtn?.addEventListener('click', () => this.move(1));
      this.onResize = this.update.bind(this);
      window.addEventListener('resize', this.onResize);

      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
    }

    getVisibleCount() {
      const styles = getComputedStyle(this);
      const desktop = window.matchMedia('(min-width: 750px)').matches;
      const raw = desktop ? styles.getPropertyValue('--pfc-cols-d') : styles.getPropertyValue('--pfc-cols-m');
      const count = parseInt(raw, 10);
      return Number.isFinite(count) && count > 0 ? count : 1;
    }

    getMaxIndex() {
      return Math.max(0, this.slides.length - this.getVisibleCount());
    }

    move(direction) {
      const maxIndex = this.getMaxIndex();
      let nextIndex = this.index + direction;

      if (this.loop && maxIndex > 0) {
        if (nextIndex < 0) nextIndex = maxIndex;
        if (nextIndex > maxIndex) nextIndex = 0;
      } else {
        nextIndex = Math.max(0, Math.min(maxIndex, nextIndex));
      }

      if (nextIndex === this.index) return;
      this.index = nextIndex;
      this.update();
    }

    update() {
      const slide = this.slides[0];
      if (!slide) return;

      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const slideWidth = slide.getBoundingClientRect().width;
      const offset = (slideWidth + gap) * this.index;
      this.track.style.transform = `translate3d(${-offset}px, 0, 0)`;

      const maxIndex = this.getMaxIndex();
      if (this.prevBtn) this.prevBtn.disabled = !this.loop && this.index <= 0;
      if (this.nextBtn) this.nextBtn.disabled = !this.loop && this.index >= maxIndex;
    }
  }

  if (!customElements.get('product-feature-carousel')) {
    customElements.define('product-feature-carousel', ProductFeatureCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-spec-accordion"] && !Shopify.designMode) return;
  try {
    
  class ProductSpecAccordion extends HTMLElement {
    connectedCallback() {
      if (this.dataset.singleOpen !== 'true') return;

      this.items = Array.from(this.querySelectorAll('.spec-acc__item'));
      this.items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          this.items.forEach((other) => {
            if (other !== item) other.open = false;
          });
        });
      });
    }
  }

  if (!customElements.get('product-spec-accordion')) {
    customElements.define('product-spec-accordion', ProductSpecAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length && tabContents.length && tabTitles.length === tabContents.length) {
      tabTitles.forEach((title, i) => {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          if (title.classList.contains('is-active')) return;
          tabTitles.forEach(t => t.classList.remove('is-active'));
          tabContents.forEach(c => c.classList.remove('is-active'));
          title.classList.add('is-active');
          setTimeout(() => {
            const content = tabContents[i];
            content.classList.add('is-animating');
            content.classList.add('is-active');
            content.addEventListener('transitionend', function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            });
          }, 10);
        });
      });
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach(toggleLink => {
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault();

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelector('.tab-title-text');
        if (tabTitleText) {
          tabTitleText.textContent = toggleLink.textContent;
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });
    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');
    
      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach(videoOpenPopup => {
          videoOpenPopup.addEventListener('click', function(e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();
  });

  } catch(e) { console.error(e); }
})();
})();
